// extracted by mini-css-extract-plugin
export default {"scaleAnalysesContainer":"styles_scaleAnalysesContainer__rjEFx","paragraphContent":"styles_paragraphContent__ddc1d"};